<template>
    <div>
        <!-- 轮播图 -->
        <div class="header">
            <div class="header-tag">Products</div>
            <!-- <div class="header-title">产品总成</div> -->
        </div>
        <!-- 产品中心 -->
        <div>
            <div class="w" style="padding: 60px 0;">
                <div>
                    <div class="text-center title">{{ info.fJ_ProductAssemblyInfo!=null?info.fJ_ProductAssemblyInfo.productNameEN:"" }}</div>
                    <!-- <div class="text-center" style="margin-top: 10px;">{{info.fJ_ProductAssemblyInfo!=null?info.fJ_ProductAssemblyInfo.productNameEN:""  }}</div> -->
                </div>
                <div class="mt-3">
                    <!--  <img src="../../assets/img/banner-02.jpg" style="width: 100%;" alt="">-->
                    <div class="bgg">

                        <img :ref="prefix+info.fJ_ProductAssemblyInfo.id" :src="http.ipAddress+info.fJ_ProductAssemblyInfo.filePath"
                                style="width: 550px;" alt="" >
                        
                    </div>
                </div>
                
                <div class="flex-row flex-wrap ">
                        <div @click="page(item.productType,item.id)" class="products-item flex-column align-center justify-center" :class="{ 'active': index == 0 }"
                            v-for="(item, index) in info.fJ_Products">
                            <img :src="http.ipAddress+item.filePath"
                            style="width: 300px;height: 300px;" alt="" >
                            <div class="item-name">{{item.productNameEN}}</div>
                        </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
// import { controllerData,  meterData} from "../products/products";
export default {
    data() {
        return {
            prefix:"product",
            switch:1,
            info:{}
        }
    },
    methods: {
        page(switchValue,index) {
            debugger
            if(switchValue==3){
                this.$router.push({path:'/productAssembly', query: {index}});
            }else{
                this.$router.push({path:'/productsDetail', query: {switch:switchValue,index}});
            }
           
        }
    },
    mounted() {
        debugger
        let index =  this.$route.query.index;
        let that=this;
        this.http.post("/api/FJ_ProductInfo/GetProductInfoAssembly",JSON.stringify({productid:parseInt(index,10),lanuage:0})).then((result)=>{
            debugger
           let objResult= eval(result);
           let iCode= objResult.code;
           if(iCode==0){
            that.info=objResult.data;
               // that.refs.product10.focus();
               // document.getElementById("product10").focus();

            }
        });



        
    }
}
</script>

<style scoped>
.header {
    background: url('../../assets/img/productbanner.jpg') no-repeat;
    background-size: 100%;
}

.bgg{
    background: url('../../assets/img/sdhh.png') no-repeat;
    background-size: 100% 100%;
    height: 450px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}
.products-item {
    width: 33%;
    padding: 30px;
    box-sizing: border-box;
    border: 1px solid #eee;
    margin-bottom: 30px;
    border: 1px solid transparent;
}

.products-item:hover {
    border: 1px solid #0AA00A;
}

.mt-3 {
    margin-top: 30px;
    line-height: 2.0;
    
}

.border {
    margin-top: 30px;
    padding-top: 30px;
    border-top: 1px solid #eee;
}

.ttitle1 {
    font-size: 16px;
    font-weight: 700;
}

.pp {
    font-size: 16px;
    line-height: 2.0;
}
</style>


// WEBPACK FOOTER //
// src/views/products/assembly.vue